module.exports = __webpack_public_path__ + "img/med_1.15bbe06a.png";